const initialFilters = [
    {
        filterGrupName: 'Status',
        field: 'status',
        filters: [
            {
                filterName: 'Received',
                checked: false,
            },
            {
                filterName: 'Scheduled',
                checked: false,
            },
            {
                filterName: 'Repair In Progress',
                checked: false,
            },
            {
                filterName: 'Rescheduled',
                checked: false,
            },
            {
                filterName: 'Repair Back In Progress',
                checked: false,
            },
            {
                filterName: 'Awaiting PO',
                checked: false,
            },
            {
                filterName: 'Canceled',
                checked: false,
            },
            {
                filterName: 'Repair Completed',
                checked: false,
            },
        ],
    },
    {
        filterGrupName: 'Submitted By',
        field: 'userName',
        filters: [],
    },
]

export const getInitialFilters = requests => {
    const peopleNames = []
    requests?.forEach(req => {
        if (!peopleNames.includes(req?.userName)) {
            peopleNames.push(req?.userName)
        }
    })
    return initialFilters?.map(fG => {
        if (fG?.field === 'userName') {
            return {
                ...fG,
                filters: peopleNames?.map(item => {
                    return {
                        filterName: item,
                        checked: false,
                    }
                }),
            }
        }
        return fG
    })
}
